import TypeBadge, { TypeBadgeSize } from './TypeBadge'

export type { TypeBadgeSize }

export default TypeBadge
